import React from "react";

import { AnimateMotion } from "@rapid/components/AnimateMotion";

const NotFound = () => {
    return (
        <AnimateMotion>
            <div>404 Not Found</div>
        </AnimateMotion>
    );
};

export default NotFound;
